var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter",class:[_vm.type]},[_vm._v("\n\t"+_vm._s(_vm.labelText)+"\n\t"),_c('button',{on:{"click":_vm.actionDelete}},[_c('Close',{attrs:{"size":14}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }